// extracted by mini-css-extract-plugin
export default {"formHeader":"GNMAReportingForm_formHeader__ndNir"};